import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import * as Constants from '../../../common/Global/constants';
import {TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton,DialogProceedButton,TableRadioButton} from '../../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    removeHtmlTags,isEmptyArray, getStatusSpan,
    handleTokenExpiry, getClientResponseDeadlineBadge} from '../../../common/Global/commonFunctions';
import {Accordion, Button, Card, Modal} from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../../common/AlertDialog';
import { DatePicker } from 'antd';
import moment from 'moment';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
class AssignForResponseObservation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            datalist:[],
            showLoader:false,

            functionMap:[],

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            showAssignResourcesDialogFlag:false,

            showResponseWarningDialog:false,
            responseWarningMessage:"",
            showResourceResponseWarningDialog:false,
            resourceResponseWarningMessage:"",

            selectedEmployee:null,
            employeeSelectKey:0,

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",

            assigneResourcesFilterDropDownArr :[],
            assignEmployeeFilterDataList:[],
            assignResourcesPlaceholder:"All",
            activeKey: null,
            activeAssignResourceKey: null
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    debounceTimers = { employee: null };

    componentDidMount(){
        this.getInitData();
    }

    // componentDidUpdate(prevProps){
    //     if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
    //         this.setState({
    //             componentDidMountFlag:false,
    //             datalist:[],
    //             showLoader:true,
    //             employeesList:[],
    //             functionMap:[],

    //             showAlertDialogInfo:false,
    //             alertDialogMessageInfo:"",

    //             // addErrors:{},
    //             showProcessFunctionsDialog:false,
    //             resourceDropdownPlaceholder:"Select Employee",
    //         })
    //     }
    // }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    // Tasks to Assignment Selection
    handleSelectionTask = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let indexAndObsId = e.target.name;
        let iapArr = indexAndObsId.split(":-:")
        let index = iapArr[0];
        let observationId = iapArr[1];
        let list = this.state.datalist;

        list.map(item => {
            if (item.obsList && item.obsList[index] && item.obsList[index].observationId == observationId) {
                item.obsList[index].isSelected = isChecked;
                item.isObsSelected = item.obsList.every(obs => obs.disabled || obs.isSelected === true);
            }
            item.newChildren.forEach(child => {
                if(child.obsList && child.obsList[index] && child.obsList[index].observationId == observationId){
                    child.obsList[index].isSelected = isChecked;

                    // Check if ALL selectable (non-disabled) observations are selected
                    child.isObsSelected = child.obsList.every(
                        obs => obs.disabled || obs.isSelected === true
                    );
                }
            })
            return item;
        })

        this.setState({
            datalist:list
        });
    }

    handleSelectionObservations = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let reportHeadingId = parseInt(e.target.name);
        let list = [...this.state.datalist];

        list.map(item => {
            if (item.reportHeadingId === reportHeadingId) {
                if (item.obsList) {
                    item.obsList.forEach(obs => {
                        if (!obs.disabled) {
                            obs.isSelected = isChecked;
                        }
                    })
                    item.isObsSelected = item.obsList.every(obs => obs.disabled || obs.isSelected === true);
                } else {
                    item.isObsSelected = isChecked;
                }
            }
            item.newChildren.forEach(child => {
                if(child.reportHeadingId === reportHeadingId){
                    if (child.obsList) {
                        child.obsList.forEach(obs => {
                            if(!obs.disabled){
                                obs.isSelected = isChecked;
                            }
                        })
                        child.isObsSelected = child.obsList.every(obs => obs.disabled || obs.isSelected === true);
                    } else {
                        child.isObsSelected = isChecked;
                    }
                }
            })
            return item;
        })

        this.setState({
            datalist: list
        });
    }

    selectAll = () => {
        let list = [...this.state.datalist];

        list.map(item => {
            if (item.obsList) {
                item.obsList.map(obs => {
                    if (!obs.disabled) {
                        obs.isSelected = true;
                    }
                    return obs;
                })
                item.isObsSelected = item.obsList.every(obs => obs.disabled || obs.isSelected === true);
            }
            item.newChildren.map(child => {
                if (child.obsList) {
                    child.obsList.map(obs => {
                        if(!obs.disabled){
                            obs.isSelected = true;
                        }
                        return obs;
                    })
                    child.isObsSelected = child.obsList.every(obs => obs.disabled || obs.isSelected === true);
                } else {
                    child.isObsSelected = true;
                }
                return child;
            })
        })

        this.setState({
            datalist: list
        });
    }

    unSelectAll = () => {
        let list = [...this.state.datalist];
        list.map(item => {
            item.isObsSelected = false;
            if (item.obsList) {
                item.obsList.map(obs => {
                    obs.isSelected = false;
                    return obs;
                })
            }
            item.newChildren.map(child => {
                child.isObsSelected = false;
                if (child.obsList) {
                    child.obsList.map(obs => {
                        obs.isSelected = false;
                        return obs;
                    })
                }
                return child;
            })
        })
        this.setState({
            datalist:list
        })
    }

    onClickAddToAssignment = () => {
        let warningObsNames = [];

        this.state.datalist.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.isSelected && obs.showResponseWarning){
                        warningObsNames.push(removeHtmlTags(obs.observationHeading));
                    }
                })
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.isSelected && obs.showResponseWarning){
                            warningObsNames.push(removeHtmlTags(obs.observationHeading));
                        }
                    })
                }
            });
        });

        if(warningObsNames.length > 0){
            this.setState({
                showResponseWarningDialog:true,
                responseWarningMessage:"Response for the below observations has been received. Do you again want to submit it for the client's response?<br/><br/><b>"
                    +warningObsNames.map(name => "&bull;&nbsp;"+name).join("<br/>")+"</b>"
            })
        }else{
            this.addSelectedToAssignment();
        }
    }

    addSelectedToAssignment = () => {
        let list = [...this.state.datalist];

        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.isSelected){
                        obs.added = true;
                    }
                })
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.isSelected){
                            obs.added = true;
                        }
                    })
                }
            });
        });

        this.setState({
            datalist:list,
            showResponseWarningDialog:false
        })
    }

    handleResponseWarningDialogClose = () => {
        let list = [...this.state.datalist];

        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.isSelected && obs.showResponseWarning){
                        obs.isSelected = false;
                    }
                })
                item.isObsSelected = item.obsList.every(obs => obs.disabled || obs.isSelected === true);
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.isSelected && obs.showResponseWarning){
                            obs.isSelected = false;
                        }
                    })
                    child.isObsSelected = child.obsList.every(obs => obs.disabled || obs.isSelected === true);
                }
            });
        });

        this.setState({
            datalist:list,
            showResponseWarningDialog:false
        })
    }

    onClickRemoveFromAssignment = () => {
        let list = [...this.state.datalist];

        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.isSelected){
                        obs.added = false;
                    }
                })
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.isSelected){
                            obs.added = false;
                        }
                    })
                }
            });
        });

        this.setState({
            datalist:list
        })
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    handleAccordionToggleAssignResource = (eventKey) => {
        if (this.state.activeAssignResourceKey === eventKey) {
            this.setState({ activeAssignResourceKey: null });
        } else {
            this.setState({ activeAssignResourceKey: eventKey });
        }
    }

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.FilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            this.state.datalist.forEach((parent)=>{
                const matchedChildren = parent.newChildren.filter(
                    child => child.heading === selectedItem.label
                );
                if (matchedChildren.length > 0 || parent.heading === selectedItem.label) {
                    const filteredParent = {
                        ...parent,
                        children: parent.children.filter(
                            ch => ch.heading === selectedItem.label
                        ),
                        newChildren: matchedChildren
                    };
                    tempFilterDataList.push(filteredParent);
                }
            })
        }
        tempFilterDataArray.forEach(item => {
            item.isSelected = item.label === selectedItem.label;
        });


        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    resourceDropdownClick = (resource) => {
        let list = [...this.state.datalist];
        let resourceCount = 0;

        list.map(item => {
            if (item.obsList) {
                item.obsList.forEach(obs => {
                    if(obs.isEmployeeTaskSelected){
                        obs.addedEmployeeToAssignment = true;
                        obs.employeeId = resource.employeeId;
                        obs.employeeFullName = resource.fullName;
                        obs.employeeType = resource.employeeType;
                        resourceCount += 1;
                    }
                    obs.isEmployeeTaskSelected = false;
                })
            }
            item.isProcSelectedInResources = false;
            item.newChildren.forEach(child => {
                if (child.obsList) {
                    child.obsList.forEach(obs => {
                        if(obs.isEmployeeTaskSelected){
                            obs.addedEmployeeToAssignment = true;
                            obs.employeeId = resource.employeeId;
                            obs.employeeFullName = resource.fullName;
                            obs.employeeType = resource.employeeType;
                            resourceCount += 1;
                        }
                        obs.isEmployeeTaskSelected = false;
                    })
                }
                child.isProcSelectedInResources = false;
            })
        })
        if(resourceCount>0){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:`${resourceCount} observations have been allocated to ${resource.fullName}`,
            })
        }
        this.setState({
            datalist:list,
            resourceCount:resourceCount,
            selectedEmployee:null,
            employeeSelectKey: this.state.employeeSelectKey + 1
        })
    }

    handleSelectionTaskInResourcesDialog = (e) => {
        e.stopPropagation();

        let isChecked = e.target.checked;
        let indexAndObsId = e.target.name;
        let iapArr = indexAndObsId.split(":-:")
        let index = iapArr[0];
        let observationId = iapArr[1];
        let list = this.state.datalist;
        let triggeredWarningName = null;

        list.map(item => {
            if (item.obsList && item.obsList[index] && item.obsList[index].observationId == observationId) {
                item.obsList[index].isEmployeeTaskSelected = isChecked;
                item.isProcSelectedInResources = item.obsList.every(obs => obs.isEmployeeTaskSelected === true);
                if(isChecked && item.obsList[index].showResponseWarning){
                    triggeredWarningName = removeHtmlTags(item.obsList[index].observationHeading);
                }
            }
            item.newChildren.forEach(child => {
                if(child.obsList && child.obsList[index] && child.obsList[index].observationId == observationId){
                    child.obsList[index].isEmployeeTaskSelected = isChecked;
                    if(isChecked && child.obsList[index].showResponseWarning){
                        triggeredWarningName = removeHtmlTags(child.obsList[index].observationHeading);
                    }

                    // Check if ALL observations are selected
                    child.isProcSelectedInResources = child.obsList.every(
                        obs => obs.isEmployeeTaskSelected === true
                    );
                }
            })
            return item;
        })

        let newState = { datalist:list };
        if(!isEmptyVariable(triggeredWarningName)){
            newState.showResourceResponseWarningDialog = true;
            newState.resourceResponseWarningMessage = "Response for the below observation has been received. Do you again want to submit it for the client's response?<br/><br/><b>&bull;&nbsp;"
                +triggeredWarningName+"</b>";
        }

        this.setState(newState);
    }

    handleResourceResponseWarningDialogClose = () => {
        let list = [...this.state.datalist];

        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.isEmployeeTaskSelected && obs.showResponseWarning){
                        obs.isEmployeeTaskSelected = false;
                    }
                })
                item.isProcSelectedInResources = item.obsList.every(obs => obs.isEmployeeTaskSelected === true);
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.isEmployeeTaskSelected && obs.showResponseWarning){
                            obs.isEmployeeTaskSelected = false;
                        }
                    })
                    child.isProcSelectedInResources = child.obsList.every(obs => obs.isEmployeeTaskSelected === true);
                }
            });
        });

        this.setState({
            datalist:list,
            showResourceResponseWarningDialog:false
        })
    }

    handleResourceResponseWarningConfirm = () => {
        this.setState({
            showResourceResponseWarningDialog:false
        })
    }

    handleSelectionProcessTasksInResourcesDialog = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let reportHeadingId = parseInt(e.target.name);
        let list = this.state.datalist;

        list.map(item => {
            if (item.reportHeadingId === reportHeadingId) {
                if (item.obsList) {
                    item.obsList.forEach(obs => {
                        obs.isEmployeeTaskSelected = isChecked;
                    })
                    item.isProcSelectedInResources = item.obsList.every(obs => obs.isEmployeeTaskSelected === true);
                } else {
                    item.isProcSelectedInResources = isChecked;
                }
            }
            item.newChildren.forEach(child => {
                if(child.reportHeadingId === reportHeadingId){
                    if (child.obsList) {
                        child.obsList.forEach(obs => {
                            if(!obs.disabled){
                                obs.isEmployeeTaskSelected = isChecked;
                            }
                        })
                        child.isProcSelectedInResources = child.obsList.every(obs => obs.disabled || obs.isEmployeeTaskSelected === true);
                    } else {
                        child.isProcSelectedInResources = isChecked;
                    }
                }
            })
            return item;
        })
        this.setState({
            datalist:list
        });
    }

    selectAllTasksResourcesDialog = () => {
        let list = [...this.state.datalist];

        list.map(item => {
            if (item.obsList) {
                item.obsList.map(obs => {
                    obs.isEmployeeTaskSelected = true;
                    return obs;
                })
                item.isProcSelectedInResources = item.obsList.every(obs => obs.disabled || obs.isEmployeeTaskSelected === true);
            }
            item.newChildren.map(child => {
                if (child.obsList) {
                    child.obsList.map(obs => {
                        if(!obs.disabled){
                            obs.isEmployeeTaskSelected = true;
                        }
                        return obs;
                    })
                    child.isProcSelectedInResources = child.obsList.every(obs => obs.disabled || obs.isEmployeeTaskSelected === true);
                } else {
                    child.isProcSelectedInResources = true;
                }
                return child;
            })
        })

        this.setState({
            datalist: list
        });
    }

    unSelectAllTasksResourcesDialog = () => {
        let list = [...this.state.datalist];

        list.map(item => {
            item.isProcSelectedInResources = false;
            if (item.obsList) {
                item.obsList.map(obs => {
                    obs.isEmployeeTaskSelected = false;
                    return obs;
                })
            }
            item.newChildren.map(child => {
                child.isProcSelectedInResources = false;
                if (child.obsList) {
                    child.obsList.map(obs => {
                        obs.isEmployeeTaskSelected = false;
                        return obs;
                    })
                }
                return child;
            })
        })

        this.setState({
            datalist: list
        });
    }

    assignResourcesDialogClose = () => {
        this.unSelectAllTasksResourcesDialog();
        this.setState({
            datalist:this.state.oldDataList,
            showAssignResourcesDialogFlag:false,
            activeAssignResourceKey:null,
            selectedEmployee:null,
            employeeSelectKey: this.state.employeeSelectKey + 1
        })
    }

    onClickNextButton = () => {
        let list = [...this.state.datalist];
        this.setState({
            showLoader:true
        })

        let isError = true;
        // let formErr = {};
        // formErr.assignTaskErr = "Please add atleast one task to the assignment"
        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.added){
                        isError = false;
                    }
                })
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.added){
                            isError = false;
                        }
                    })
                }
            })
        })

        let tempFilterArray = [
            {
                label: "All",
                isSelected: true,
            },
        ];

            
        Object.values(this.state.datalist).map((obsObj)=>{
            if (obsObj.obsList && obsObj.obsList.some(item => item.added === true)) {
                tempFilterArray.push({
                    label:`${obsObj.heading}`,
                    isSelected:false
                })
            }
            obsObj.newChildren.forEach(child => {
                let showTasks = child.obsList && child.obsList.some((item) => item.added === true);
                if(showTasks){
                    tempFilterArray.push({
                        label:`${child.heading}`,
                        isSelected:false
                    })
                }
            })
        })
        let oldDataList = JSON.parse(JSON.stringify(this.state.datalist));
        //now do the validation
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
            	alertDialogMessageInfo:"Please add atleast one observation to the assignment"
            });
        }else{
            this.setState({
                showAssignResourcesDialogFlag:true,
                showLoader:false,
                oldDataList:oldDataList,
                assignEmployeeFilterDataList:[],
                assigneResourcesFilterDropDownArr:tempFilterArray,
                assignResourcesPlaceholder:"All"
            })
        }
    }

    assigneResourceFilterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.assigneResourcesFilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            this.state.datalist.forEach((parent)=>{
                const matchedChildren = parent.newChildren.filter(
                    child => child.heading === selectedItem.label
                );
                if (matchedChildren.length > 0 || parent.heading === selectedItem.label) {
                    const filteredParent = {
                        ...parent,
                        children: parent.children.filter(
                            ch => ch.heading === selectedItem.label
                        ),
                        newChildren: matchedChildren
                    };
                    tempFilterDataList.push(filteredParent);
                }
            })
        }
        tempFilterDataArray.forEach(item => {
            item.isSelected = item.label === selectedItem.label;
        });
        this.setState({
            assignEmployeeFilterDataList:tempFilterDataList,
            assigneResourcesFilterDropDownArr:tempFilterDataArray,
            assignResourcesPlaceholder:selectedItem.label
        })
    }

    onClickAddResourceToAssignment = () => {
        let list = [...this.state.datalist];

        let isError = false;
        let hasSelection = false;
        list.forEach(item => {
            if (!isEmptyArray(item.obsList)) {
                item.obsList.forEach(obs => {
                    if(obs.addedEmployeeToAssignment || (obs.isEmployeeTaskSelected && !isEmptyVariable(obs.employeeId))){
                        hasSelection = true;
                    }
                    if(obs.added && isEmptyVariable(obs.employeeId)){
                        isError = true;
                    }
                })
            }
            item.newChildren.forEach(child => {
                if (!isEmptyArray(child.obsList)) {
                    child.obsList.forEach(obs => {
                        if(obs.addedEmployeeToAssignment || (obs.isEmployeeTaskSelected && !isEmptyVariable(obs.employeeId))){
                            hasSelection = true;
                        }
                        if(obs.added && isEmptyVariable(obs.employeeId)){
                            isError = true;
                        }
                    })
                }
            })
        })

        if(!hasSelection){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please select at least one observation and assign a resource"
            })
        }else if(isError){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            Object.values(this.state.datalist).map((obsObj)=>{
                if (obsObj.obsList) {
                    obsObj.obsList.forEach(obs => {
                        if(obs.added && !isEmptyVariable(obs.employeeId) && (obs.addedEmployeeToAssignment || obs.isEmployeeTaskSelected)){
                            let obj = {
                                employeeId:obs.employeeId,
                                employeeType:obs.employeeType
                            }

                            if(!isEmptyVariable(obs.observationId)){
                                obj.observationId = obs.observationId;
                            }
                            assignmentTasks.push(obj);
                        }
                    })
                }
                obsObj.newChildren.forEach(child => {
                    if (child.obsList) {
                        child.obsList.forEach(obs => {
                            if(obs.added && !isEmptyVariable(obs.employeeId) && (obs.addedEmployeeToAssignment || obs.isEmployeeTaskSelected)){
                                let obj = {
                                    employeeId:obs.employeeId,
                                    employeeType:obs.employeeType
                                }

                                if(!isEmptyVariable(obs.observationId)){
                                    obj.observationId = obs.observationId;
                                }
                                assignmentTasks.push(obj);
                            }
                        })
                    }
                })
            })
            this.setState({
                showNextDateDialog:true,
                assignmentTasks:JSON.stringify(assignmentTasks)
            })
        }
    }

    handleDateDialogClose = () => {
        this.setState({
            showNextDateDialog:false,
            assignmentTasks:[]
        })
    }

    handleClear = () => {
        this.setState({
            deadlineDate:null,
            selectedOption:""
        })
    }

    // if onDateChange already exists, replace it; otherwise add this handler
    onDateChange = (date, dateString) => {
        // when user picks a date, clear radio selection so radios become disabled
        this.setState({
            deadlineDate:isEmptyVariable(date)?null:date.format("YYYY-MM-DD")
        })
    }

    handleCheck = (e) =>{
        let selectedOption = e.target.value;
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['option'] = "";
        }

        this.setState({
            selectedOption
        })
    }

    /*******************API CALLS*******************/
    getInitData = () => {
        fetch(Constants.GetEmployeeOrAuditee+"/"+this.props.assignmentId,{
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => response.json())
        .then(data => {
            if(handleTokenExpiry(data.responseCode)) return;

            let employeeData = [];
            if(data.responseCode === Constants.CODE_SUCCESS){
                employeeData = data.data;
            }

            let tempFilterArray = [{ label:"All", isSelected:true }];
            let datalist = this.props.datalist.dataSource;

            datalist.map((obsObj)=>{
                if (obsObj.obsList) {
                    obsObj.obsList.forEach(obs => {
                        obs.employeeData = employeeData.filter(e => e.observationId === obs?.observationId);
                        if(!isEmptyArray(obs.employeeData)){
                            obs.added = true;
                            obs.employeeFullName = obs.employeeData[0].employeeDetails.firstName + " " + obs.employeeData[0].employeeDetails.lastName + " ("+obs.employeeData[0].employeeDetails.designation+")";
                            obs.employeeId = obs.employeeData[0].employeeDetails.employeeId;
                            obs.employeeType = obs.employeeData[0].userType;
                            obs.clientResponseDeadline = obs.employeeData[0].clientResponseDeadline;
                            obs.hasAddedResponse = obs.employeeData[0].hasAddedResponse;
                            obs.disabled = obs.allowClientReAssign === false;
                        } else {
                            obs.disabled = obs.allowClientReAssign === false;
                        }
                    })
                }
                obsObj.newChildren.forEach(child => {
                    (child?.obsList || []).forEach(obs => {
                        obs.employeeData = employeeData.filter(e => e.observationId === obs?.observationId);
                        if(!isEmptyArray(obs.employeeData)){
                            obs.added = true;
                            obs.employeeFullName = obs.employeeData[0].employeeDetails.firstName + " " + obs.employeeData[0].employeeDetails.lastName + " ("+obs.employeeData[0].employeeDetails.designation+")";
                            obs.employeeId = obs.employeeData[0].employeeDetails.employeeId;
                            obs.employeeType = obs.employeeData[0].userType;
                            obs.clientResponseDeadline = obs.employeeData[0].clientResponseDeadline;
                            obs.hasAddedResponse = obs.employeeData[0].hasAddedResponse;
                            obs.disabled = obs.allowClientReAssign === false;
                        } else {
                            obs.disabled = obs.allowClientReAssign === false;
                        }
                    })
                })
            })
            Object.values(datalist).map((obsObj)=>{
                if (obsObj.obsList && obsObj.obsList.length > 0) {
                    tempFilterArray.push({ label:`${obsObj.heading}`, isSelected:false })
                }
                obsObj.newChildren.forEach(child => {
                    tempFilterArray.push({ label:`${child.heading}`, isSelected:false })
                })
            })
            this.setState({
                employeeData:employeeData,
                datalist:datalist,
                FilterDropDownArr:tempFilterArray,
                componentDidMountFlag:true
            })
        })
    }

    getEmployeesList = (inputValue) => {
        clearTimeout(this.debounceTimers.employee);
        return new Promise((resolve) => {
            if (!inputValue || inputValue.length < 3) {
                resolve({ options:[], hasMore:false });
                return;
            }
            this.debounceTimers.employee = setTimeout(() => {
                fetch(Constants.EmployeeOrAuditeeList,{
                    method:"POST",
                    mode:'cors',
                    body: new URLSearchParams({
                        email:userDetails.email,
                        accessToken:userDetails.accessToken,
                        search:inputValue,
                        assignmentId:this.props.assignmentId
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)){
                        resolve({ options:[] });
                        return;
                    }
                    if(data.responseCode === Constants.CODE_SUCCESS){
                        const draftAssignmentAuditeeList = data.data.draftAssignmentAuditeeList || [];
                        const clientEmployeeList = data.data.clientEmployeeList || [];

                        const markedAuditees = draftAssignmentAuditeeList.map(emp => ({
                            ...emp,
                            isAuditee:true,
                            fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                        }));
                        const regularEmployees = clientEmployeeList.map(emp => ({
                            ...emp,
                            isAuditee:false,
                            fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                        }));
                        resolve({ options:[...markedAuditees, ...regularEmployees], hasMore:false });
                    } else {
                        resolve({ options:[] });
                    }
                })
                .catch(() => resolve({ options:[] }));
            }, 300);
        });
    }

    handleEmployeeSelect = (selectedEmp) => {
        this.setState({ selectedEmployee:selectedEmp });
        this.resourceDropdownClick(selectedEmp);
    }

    handleProceedButtonClick = () => {
        let isError = false;
        if(isEmptyVariable(this.state.deadlineDate) && isEmptyVariable(this.state.selectedOption)){
            isError = true;
        }
        if(isError){
            this.setState({
                errorMsg:"Please select a date",
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            let deadlineDate = "";
            if(!isEmptyVariable(this.state.selectedOption)){
                const days = parseInt(this.state.selectedOption);
                deadlineDate = moment().add(days + 1, 'days').startOf('day').toISOString();
            }else{
                deadlineDate = moment(this.state.deadlineDate, 'YYYY-MM-DD').startOf('day').toISOString();
            }

            //call the fetch function
            fetch(Constants.SaveEmployeeOrAuditee,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    aeList:this.state.assignmentTasks,
                    assignmentId:this.props.assignmentId,
                    clientResponseDeadline:deadlineDate
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.handleDateDialogClose();
                    this.assignResourcesDialogClose();
                    this.handleClear();
                    this.getEmployeeOrAuditee();
                    this.unSelectAll();
                    this.setState({ dataChanged:true });
                }else{
                    this.handleClear();
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    }

    getEmployeeOrAuditee = () => {
        fetch(Constants.GetEmployeeOrAuditee+"/"+this.props.assignmentId,{
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let employeeData = data.data;
                let datalist = this.props.datalist.dataSource;
                
                datalist.map((obsObj)=>{
                    if (obsObj.obsList) {
                        obsObj.obsList.forEach(obs => {
                            obs.employeeData = employeeData.filter(e => e.observationId === obs.observationId);
                            if(!isEmptyArray(obs.employeeData)){
                                obs.added = true;
                                obs.employeeFullName = obs.employeeData[0].employeeDetails.firstName + " " + obs.employeeData[0].employeeDetails.lastName + " ("+obs.employeeData[0].employeeDetails.designation+")";
                                obs.employeeId = obs.employeeData[0].employeeDetails.employeeId;
                                obs.employeeType = obs.employeeData[0].userType;
                                obs.clientResponseDeadline = obs.employeeData[0].clientResponseDeadline;
                            obs.hasAddedResponse = obs.employeeData[0].hasAddedResponse;
                                obs.disabled = obs.allowClientReAssign === false;
                            } else {
                                obs.disabled = obs.allowClientReAssign === false;
                            }
                        })
                    }
                    obsObj.newChildren.forEach(child => {
                        if (child.obsList) {
                            child.obsList.forEach(obs => {
                                obs.employeeData = employeeData.filter(e => e.observationId === obs.observationId);
                                if(!isEmptyArray(obs.employeeData)){
                                    obs.added = true;
                                    obs.employeeFullName = obs.employeeData[0].employeeDetails.firstName + " " + obs.employeeData[0].employeeDetails.lastName + " ("+obs.employeeData[0].employeeDetails.designation+")";
                                    obs.employeeId = obs.employeeData[0].employeeDetails.employeeId;
                                    obs.employeeType = obs.employeeData[0].userType;
                                    obs.clientResponseDeadline = obs.employeeData[0].clientResponseDeadline;
                            obs.hasAddedResponse = obs.employeeData[0].hasAddedResponse;
                                    obs.disabled = obs.allowClientReAssign === false;
                                } else {
                                    obs.disabled = obs.allowClientReAssign === false;
                                }
                            })
                        }
                    })
                })
                this.setState({
                    employeeData:employeeData,
                    datalist:datalist
                })
            }else{

            }
        })
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <Router>
                {
                    this.state.componentDidMountFlag &&
                    <div className="m-t-10">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <div className="prev-next-layout">
                            <div className="flex-center-layout secondary-top-bar">
                                <div className="back-btn-layout" onClick={()=>{
                                    this.unSelectAll();
                                    this.props.handleAssignForResponseDialogClose(this.state.dataChanged);
                                }}>
                                <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{"Assign For Response"}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>
                                <AddNewButtonLayout themeSettings={themeSettings}
                                style={{marginRight:5}}>
                                    <a onClick={this.onClickRemoveFromAssignment} href="javascript:void(0);">
                                        <span className="material-icons">remove_circle_outline</span>
                                        <p>Remove</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a onClick={this.onClickAddToAssignment} href="javascript:void(0);">
                                        <span className="material-icons">add_circle</span>
                                        <p>Add for Response</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:5}}>
                                    <a onClick={this.onClickNextButton} href="javascript:void(0);">
                                        {/* <span className="material-icons">add_circle</span> */}
                                        <p>Next</p>
                                        <span class="material-icons-outlined">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {
                                Object.values(isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList).map((obsObj,index)=>{
                                    const allNodes = [];
                                    if (obsObj.obsList && obsObj.obsList.length > 0) {
                                        allNodes.push({
                                            ...obsObj,
                                            heading: obsObj.heading,
                                            isTopLevelObs: true
                                        });
                                    }
                                    if (obsObj.newChildren) {
                                        obsObj.newChildren.forEach(child => {
                                            if (child.type === 'heading') {
                                                allNodes.push({
                                                    ...child,
                                                    heading: (obsObj.heading ? `${obsObj.heading} > ` : '') + (child.heading || child.nodeText || '')
                                                });
                                            }
                                        });
                                    }

                                    return allNodes.map((child, childIdx) => {
                                        let className;
                                        if (index === 0 && childIdx === 0) {
                                            className = 'card-radius'; // CSS for the first item
                                        } else if (index === (Object.values(isEmptyArray(this.state.filterDataList)?
                                            this.state.datalist:this.state.filterDataList).length - 1) && childIdx === (allNodes.length - 1)) {
                                            className = 'card-last'; // CSS for the last item
                                        } else {
                                            className = 'card-middle'; // CSS for all other items
                                        }
                                        const headerText = child.isTopLevelObs ? child.heading : child.heading;
                                        return <div className="process-task-list" key={`${child.reportHeadingId}`}>
                                            <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                                <Card className={className}> 
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={child.reportHeadingId}
                                                            onClick={() => this.handleAccordionToggle(child.reportHeadingId)}
                                                        >
                                                            <div className='row align-items-center'>
                                                                <TableCheckBox onClick={this.handleStopPropagation}
                                                                    themeSettings={themeSettings}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={child.reportHeadingId}
                                                                        id={child.reportHeadingId}
                                                                        onChange={this.handleSelectionObservations}
                                                                        disabled={isEmptyArray(child.obsList) || child.obsList.every(obs => obs.disabled)}
                                                                        checked={child.isObsSelected?true:false}
                                                                    />
                                                                    <label for={child.reportHeadingId} 
                                                                    style={{marginLeft:-3}}></label>
                                                                </TableCheckBox>
                                                                <h6 className='col-md-6 text-left'>{headerText}</h6>
                                                                    {
                                                                        child?.obsList?.length > 0 &&
                                                                        <h6 className='col-md-2 text-left'>{"Total Task: "+child.obsList.length}</h6>
                                                                    }
                                                                <h6 className='col-md-3 text-center'>{"Added to Assignment: "+(child.obsList || []).filter(item => item.added == true).length}</h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header> 
                                                    <Accordion.Collapse eventKey={child.reportHeadingId}>
                                                        <Card.Body>
                                                            {
                                                                !isEmptyArray(child.obsList) && 
                                                                <div className="common-tab-bg">
                                                                    <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                        <div className="table-custom-layout">
                                                                            <div className="table-custom-header">
                                                                                <div className="table-custom-header-row">
                                                                                    <p style={{width:"5%"}}></p>
                                                                                    <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                                    <p style={{width:"42%"}}>Observation</p>
                                                                                    <p style={{width:"25%"}}>Employee</p>
                                                                                    <p style={{width:"15%"}}>Response Deadline</p>
                                                                                    <p style={{width:"8%"}}>Added</p>
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            <div className="table-custom-body">
                                                                            {
                                                                                !isEmptyArray(child.obsList) && 
                                                                                child.obsList.map((item,idx) => {
                                                                                    // let spanObj = getStatusSpan(item.status,themeSettings);
                                                                                    const isLastRow = idx === child.obsList.length - 1;
                                                                                    return <CustomTableRow themeSettings={themeSettings}
                                                                                    className={item.disabled?"row-disable":""}>
                                                                                        <div className="table-cell" style={{width:"5%"}}>
                                                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                                                themeSettings={themeSettings}>
                                                                                                <input 
                                                                                                    type="checkbox"
                                                                                                    name={idx+":-:"+item.observationId}
                                                                                                    id={idx+":-:"+item.observationId}
                                                                                                    onChange={this.handleSelectionTask}
                                                                                                    disabled={item.disabled}
                                                                                                    checked={item.isSelected?true:false}
                                                                                                />
                                                                                                <label for={idx+":-:"+item.observationId} 
                                                                                                style={{marginLeft:6}}></label>
                                                                                            </TableCheckBox>
                                                                                        </div>
                                                                                        <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                        <p style={{width:"42%"}}>
                                                                                            <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.observationHeading}} />
                                                                                            {
                                                                                                item.showResponseWarning &&
                                                                                                <span className={"tool"+(isLastRow?" tool-top":"")} data-title="Client has responded on the observation."
                                                                                                    style={{marginLeft:6, verticalAlign:"middle", cursor:"pointer"}}>
                                                                                                    <span className="material-icons" style={{fontSize:18, verticalAlign:"middle"}}>done_all</span>
                                                                                                </span>
                                                                                            }
                                                                                            {/* {
                                                                                                item.added &&
                                                                                                <span style={{marginLeft:6}} className="material-icons">done_all</span>
                                                                                            } */}
                                                                                            {/* {
                                                                                                !isEmptyVariable(spanObj.spanText) &&
                                                                                                <span style={spanObj.spanStyle} className="span-tag">
                                                                                                    {spanObj.spanText}
                                                                                                </span>
                                                                                            } */}
                                                                                        </p>
                                                                                        <p style={{width:"25%"}}>
                                                                                            {isEmptyArray(item.employeeData)?"":
                                                                                                item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                            }
                                                                                        </p>
                                                                                        <p style={{width:"15%"}}>
                                                                                            {(() => {
                                                                                                const deadlineBadge = item.hasAddedResponse == true ? null : getClientResponseDeadlineBadge(item.clientResponseDeadline);
                                                                                                return deadlineBadge ? (
                                                                                                    <div className={"tool"+(isLastRow?" tool-top":"")} data-title={deadlineBadge.tooltip}
                                                                                                        style={{
                                                                                                            display:"inline-block",
                                                                                                            padding:"3px 10px",
                                                                                                            borderRadius:12,
                                                                                                            fontSize:11, fontWeight:600, whiteSpace:"nowrap",
                                                                                                            background:deadlineBadge.bgColor, color:deadlineBadge.textColor
                                                                                                        }}>
                                                                                                        {deadlineBadge.text}
                                                                                                    </div>
                                                                                                ) : "-";
                                                                                            })()}
                                                                                        </p>
                                                                                        <p style={{width:"8%"}}>
                                                                                            {
                                                                                                item.added &&
                                                                                                <span class="material-icons"
                                                                                                style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                            }
                                                                                        </p>
                                                                                        
                                                                                    </CustomTableRow>
                                                                                })
                                                                            }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                            {
                                                this.state.componentDidMountFlag && isEmptyArray(child.obsList) &&
                                                <div class="no-items-layout">
                                                    <div class="no-items-card" style={{padding:"10px"}}>
                                                        <h6 style={{margin:0}}>
                                                        {
                                                            Constants.NO_RECORDS_WARNING
                                                        }
                                                        </h6>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    })
                                })
                            }
                        </div>
                    </div>
                }
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showResponseWarningDialog}
                    handleAlertDialogClose={this.handleResponseWarningDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={"Response Already Received"}
                    alertDialogMessage={this.state.responseWarningMessage}
                    proceedBtnClick={this.addSelectedToAssignment}
                    proceedBtnLabel={"Yes"}
                    themeSettings={themeSettings}
                />
                <AlertDialog
                    showAlertDialog={this.state.showResourceResponseWarningDialog}
                    handleAlertDialogClose={this.handleResourceResponseWarningDialogClose}
                    type={Constants.ALERT_TYPE_WARNING}
                    alertDialogHeading={"Response Already Received"}
                    alertDialogMessage={this.state.resourceResponseWarningMessage}
                    proceedBtnClick={this.handleResourceResponseWarningConfirm}
                    proceedBtnLabel={"Yes"}
                    themeSettings={themeSettings}
                />
                {this.state.showAssignResourcesDialogFlag &&
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.state.showAssignResourcesDialogFlag} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>Assign Client</h5>
                        <button 
                            onClick={this.assignResourcesDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="search-addnew-bg" style={{marginTop:0}}>
                                <div className="search-addnew">
                                    <div className="flex-center-layout">
                                        <div style={{ marginRight: 10 }}>
                                            <FilterDropDown
                                                placeholder={this.state.assignResourcesPlaceholder}
                                                dropdownArr={this.state.assigneResourcesFilterDropDownArr}
                                                onDropDownItemClick={this.assigneResourceFilterDropDownOnClick}
                                                themeSettings={themeSettings}
                                                name={"label"}
                                                dropdownWidth="200px"
                                            />
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.unSelectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box_outline_blank
                                                </span>
                                                <p>Unselect All</p>
                                            </a>
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.selectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box
                                                </span>
                                                <p>Select All</p>
                                            </a>
                                        </div>
                                        <div style={{width:"300px"}}>
                                            <AsyncPaginate
                                                key={this.state.employeeSelectKey}
                                                value={this.state.selectedEmployee}
                                                loadOptions={this.getEmployeesList}
                                                defaultOptions={false}
                                                cacheOptions={false}
                                                placeholder="Search Employee..."
                                                getOptionLabel={(e) => e.fullName}
                                                getOptionValue={(e) => e.employeeId}
                                                onChange={this.handleEmployeeSelect}
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue && inputValue.length >= 3 ? "No employees found" : "Type at least 3 characters to search"
                                                }
                                                formatOptionLabel={(emp, { context }) => {
                                                    if(context === "value") return <span>{emp.fullName}</span>;
                                                    return (
                                                        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between"}}>
                                                            <span style={{flex:1, marginRight:"8px"}}>{emp.fullName}</span>
                                                            {emp.isAuditee && (
                                                                <span style={{
                                                                    fontSize:"10px", fontWeight:"600",
                                                                    color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`,
                                                                    border:`1px solid rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`,
                                                                    borderRadius:"10px", padding:"1px 7px",
                                                                    whiteSpace:"nowrap", flexShrink:0
                                                                }}>Auditee</span>
                                                            )}
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <DialogSaveButton themeSettings={themeSettings} 
                                        onClick={this.onClickAddResourceToAssignment} type="button" 
                                        className="modal-save m-b-0">Assign</DialogSaveButton>
                                    </div>
                                </div>       
                            </div>
                            <div className="assign-taskresource accordion-layout" style={{position:"relative"}}>
                                {Object.values(isEmptyArray(this.state.assignEmployeeFilterDataList)?this.state.datalist:this.state.assignEmployeeFilterDataList)
                                .map((obsObj,index)=>{
                                    const allNodes = [];
                                    if (obsObj.obsList && obsObj.obsList.some(item => item.added === true)) {
                                        allNodes.push({
                                            ...obsObj,
                                            heading: obsObj.heading,
                                            isTopLevelObs: true
                                        });
                                    }
                                    if (obsObj.newChildren) {
                                        obsObj.newChildren.forEach(child => {
                                            if (child.type === 'heading' && child.obsList && child.obsList.some(item => item.added === true)) {
                                                allNodes.push({
                                                    ...child,
                                                    heading: (obsObj.heading ? `${obsObj.heading} > ` : '') + (child.heading || child.nodeText || '')
                                                });
                                            }
                                        });
                                    }

                                return allNodes.map((child, childIdx) => {
                                    let showTasks = false;
                                    let className;
                                    if (index === 0 && childIdx === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === ((Object.values(isEmptyArray(this.state.assignEmployeeFilterDataList)?
                                        this.state.datalist:this.state.assignEmployeeFilterDataList)).length - 1) && childIdx === (allNodes.length - 1)) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    const headerText = child.heading;
                                    // showTasks=!!obsObj.taskList.find(({added}) =>added===true)
                                    showTasks = child.obsList && child.obsList.some((item) => item.added === true)
                                    const addedObsInChild = (child.obsList || []).filter(item => item.added === true);
                                    const allAddedDisabled = addedObsInChild.every(item => item.disabled);
                                    if(showTasks){
                                        return <div className="process-task-list">
                                            <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeAssignResourceKey}>
                                                <Card className={className}> 
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={child.reportHeadingId}
                                                            onClick={() => this.handleAccordionToggleAssignResource(child.reportHeadingId)}
                                                        >
                                                            <div className='row align-items-center'>
                                                                <TableCheckBox
                                                                    themeSettings={themeSettings}>
                                                                    <input
                                                                        type="checkbox"
                                                                        name={child.reportHeadingId}
                                                                        id={"RES"+child.reportHeadingId}
                                                                        onChange={this.handleSelectionProcessTasksInResourcesDialog}
                                                                        disabled={allAddedDisabled}
                                                                        checked={child.isProcSelectedInResources?true:false}
                                                                    />
                                                                    <label for={"RES"+child.reportHeadingId} 
                                                                    style={{marginLeft:5}}></label>
                                                                </TableCheckBox> 
                                                                <h6 className='col-md-6 text-left'>{headerText}</h6>
                                                                {
                                                                   (child.obsList || []).filter(item => item.added === true).length > 0 &&
                                                                   <h6 className='col-md-2 text-left'>{"Total Task: "+child.obsList.filter(item => item.added === true).length}</h6>
                                                               }
                                                               <h6 className='col-md-3 text-center'>{"Employee Assigned: "+(child.obsList || []).filter(item => item.added == true).length}</h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header> 
                                                    <Accordion.Collapse eventKey={child.reportHeadingId}>
                                                        <Card.Body>                                            
                                                            {
                                                                !isEmptyArray(child.obsList) && 
                                                                <div className="common-tab-bg">
                                                                    <div className="common-table" style={{width:"100%"}}>
                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="text-center" width={"8%"}></th>
                                                                                    <th className="text-center" width={"5%"}>No.</th>
                                                                                    <th width={"55%"}>Observations</th>
                                                                                    <th width={"33%"}>Employees</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {
                                                                               !isEmptyArray(child.obsList) &&
                                                                               (totalAdded => (visibleRowNo => (child.obsList || []).map((item,idx) => {
                                                                                    if(item.added){
                                                                                        visibleRowNo++;
                                                                                        const isLastVisible = visibleRowNo === totalAdded;
                                                                                        return <tr className={item.disabled?"row-disable":""}>
                                                                                            <td>
                                                                                                <TableCheckBox
                                                                                                    themeSettings={themeSettings}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        name={idx+":-:"+item.observationId}
                                                                                                        id={idx+":-:"+"RES"+item.observationId}
                                                                                                        onChange={this.handleSelectionTaskInResourcesDialog}
                                                                                                        disabled={item.disabled}
                                                                                                        checked={item.isEmployeeTaskSelected?true:false}
                                                                                                    />
                                                                                                    <label for={idx+":-:"+"RES"+item.observationId}
                                                                                                    style={{marginLeft:6}}></label>
                                                                                                </TableCheckBox>
                                                                                            </td>
                                                                                            <td className="text-center">{visibleRowNo}</td>
                                                                                            <td>
                                                                                                <div className="flex-center-layout">
                                                                                            <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.observationHeading}} />                                                                                                {
                                                                                                    item.completionStatus==="Completed" &&
                                                                                                    <span style={{marginLeft:6,fontSize:18}}
                                                                                                    className="material-icons">done_all</span>
                                                                                                }
                                                                                                {
                                                                                                    item.showResponseWarning &&
                                                                                                    <span className={"tool"+(isLastVisible?" tool-top":"")} data-title="Client has responded on the observation."
                                                                                                        style={{marginLeft:6, verticalAlign:"middle", cursor:"pointer"}}>
                                                                                                        <span className="material-icons" style={{fontSize:18, verticalAlign:"middle"}}>done_all</span>
                                                                                                    </span>
                                                                                                }
                                                                                                </div>
                                                                                            </td>
                                                                                            <td>{isEmptyVariable(item.employeeFullName)?"":item.employeeFullName}</td>
                                                                                        </tr>
                                                                                    }
                                                                                }))(0))((child.obsList || []).filter(o => o.added).length)
                                                                            }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    }
                                })
                                
                                })
                            }
                            </div>
                        </div>
                    </div>
                </Modal>
                }
                <Modal className="custom-dialog" show={this.state.showNextDateDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{"Response Deadline Date"}</h5>
                        <button 
                            onClick={this.handleDateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <div class="modal-body">
                        <div className="addnew-modal-form">
                            <div class="addnew-modal-form-group">
                                <DatePicker
                                    onChange={this.onDateChange}
                                    value={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):null}
                                    format={"DD/MM/YYYY"}
                                    placeholder="Select Date"
                                    disabledDate={(current) => current.isSameOrBefore(moment(), "day")}
                                    // selectedItem={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):""}
                                    disabled={!isEmptyVariable(this.state.selectedOption)} // disable when radio selected
                                />
                            </div>
                            <div className='addnew-modal-form-group'>
                                <div className="radio-group radio-group-inline">
                                    <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center"}}>
                                        <TableRadioButton
                                            key={'7'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"7"}
                                                id={"deadline"+":-:"+"7"}
                                                value={'7'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "7"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"7"} style={{marginLeft:0}}>7 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'10'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"10"}
                                                id={"deadline"+":-:"+"10"}
                                                value={'10'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "10"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"10"} style={{marginLeft:0}}>10 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'15'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name={"deadline"+":-:"+"15"}
                                                id={"deadline"+":-:"+"15"}
                                                value={'15'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "15"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={"deadline"+":-:"+"15"} style={{marginLeft:0}}>15 Days</label>
                                        </TableRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }

                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleDateDialogClose}
                            >Cancel</a>
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleClear}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >Clear</a>
                            <DialogProceedButton
                                themeSettings={themeSettings}
                                class="alert-proceed"
                                href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : "Save"}
                            </DialogProceedButton>
                        </div>
                    </div>
                </Modal>
            </Router>
        );
    }
}

export default AssignForResponseObservation;
